exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*.purchased.v-list{ padding : 0;  }*/\n.v-data-table__expanded__content .purchased.v-list {\n  max-width: 85%;\n  margin: auto;\n}\n.voided .v-list-item__content,\n.canceled .v-list-item__content,\n.refunded .v-list-item__content {\n  text-decoration: line-through;\n}\n.pending .v-list-item__content {\n  font-style: italic\n}\n.deleted {\n  display: none\n}\n.credit {\n  display: inline;\n}\n\n/* */\n.purchased .v-list-item__content>* {\n  flex: none\n}\n", ""]);

// exports
